<template>
  <div>
      Copyright © 2028 锐单电子 All Rights Reserved
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      
    };
  },
  props:['show'],
  methods: {
    
  }
};
</script>


<style>
.footer_guide {
  border-top: 1px soild #e4e4e4;
  height: 60px;
  z-index: 100;
  bottom: 1px;
  width: 100%;
  /*实现水平居中*/
  justify-content: center;
  /*flex 布局*/
  display: flex;
  /*实现垂直居中*/
  align-items: center;
  background-color: #0fa0ec;
}
</style>


// WEBPACK FOOTER //
// src/components/common/footer.vue